import axios from 'axios';
import { get, head, values, includes, isString, isObject } from 'lodash';

import { getToken, removeLoggedInDetail } from '@utils/storage';
import { Notifier } from '@components';
import { store } from '@state/store';
import i18n from '../../i18n';

export function authRequest(config) {
  const token = getToken();
  if (token) {
    config.headers.Authorization = `${token.type} ${token.token}`;
  }
  config.headers['X-Localization'] = i18n.language;
  return config;
}

export const authResponse = [
  function (response) {
    const { data, ...meta } = response.data;
    if (!data) return { data: response.data };
    return { data, meta };
  },
  function (error) {
    const isWorkingHoursError =
      error?.response?.data?.type === 'outside_working_hours';

    if (error && error.response && 401 === error.response.status) {
      removeLoggedInDetail();

      store.dispatch({ type: 'SESSION_LOGOUT' });
      window.location.reload();
    }
    if (!axios.isCancel(error)) {
      const err = get(error, 'response.data.errors', 'Error!');
      const errMsg = isObject(err) ? head(head(values(err))) : err;

      const apiUrl = get(error, 'config.url');
      const isMaintenance = apiUrl === '/public/status';
      const noError = includes(apiUrl, ['error=false']);

      if (!noError && !isMaintenance && !isWorkingHoursError) {
        Notifier.error(isString(errMsg) ? errMsg : 'Error!');
      }
    }
    if (
      error &&
      error.response &&
      404 === error.response.status &&
      !isWorkingHoursError
    ) {
      Notifier.error('Error');
    }
    return Promise.reject(error);
  },
];
